// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserSearch_wrapper__2urmQ","search":"UserSearch_search__2ERpY"};